var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Card',[_c('Tabs',{attrs:{"type":"card","closable":""},on:{"on-tab-remove":_vm.handleTabRemove}},[_c('TabPane',{attrs:{"closable":false,"label":"数据统计"}},[_c('home')],1)],1)],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66655db8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/report/patientOut/index.vue
// module id = null
// module chunks = 